module.exports = __webpack_public_path__ + "static/media/bike.e4be2515.svg";